import { FC, useCallback, useEffect, useMemo } from "react";

import { SelectOption } from "../../utils/models";
import { transformUserItem } from "../../utils/utilities";

import { getUsers, loadUsers } from "../../store/users";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";

function withUsers(Component: any): FC<any> {
  return function WithUsers(props): JSX.Element {
    const dispatch = useAppDispatch();
    const users = useAppSelector(getUsers);

    const usersForDropdown = useMemo((): SelectOption[] => {
      return users.users.map(transformUserItem);
    }, [users.users]);

    const refreshUsers = useCallback(() => {
      dispatch(loadUsers());
    }, [dispatch]);

    useEffect(() => {
      refreshUsers();
    }, [refreshUsers]);

    return (
      <Component
        users={users.users}
        supervisors={users.supervisors}
        usersForDropdown={usersForDropdown}
        usersLoading={users.loading}
        usersError={users.error}
        refreshUsers={refreshUsers}
        usersLastUpdated={users.lastUpdated}
        {...props}
      />
    );
  };
}

export default withUsers;
